/**
 * Le compte de l'application.
 *
 * Il porte deja une coche a cote de son pseudo ; il porte desormais
 * aussi ce qu'on ne peut pas lui faire. Ce n'est pas un membre comme les
 * autres : il ne joue pas au jeu qu'il propose — donc ni destinations ni
 * trophees —, on ne le demande pas en ami, on ne le fait pas sonner, et
 * on ne le signale pas a l'equipe qui le tient. Ce qui reste ouvert, et
 * c'est bien le point, c'est de lui ecrire.
 *
 * Un seul drapeau en base decide de tout cela : `users/{uid}/officiel`.
 * Personne n'ecrit d'identifiant en dur, ici ni ailleurs.
 *
 * La lecture est tolerante : un profil illisible n'est pas le compte
 * officiel, et une porte qu'on n'arrive pas a interroger ne doit pas
 * emporter le geste entier.
 */
import { paths } from './paths';
import { readOptionalValue } from './rtdb';

export async function estCompteOfficiel(uid: string): Promise<boolean> {
  return (await readOptionalValue<boolean>(paths.userField(uid, 'officiel'))) === true;
}
